import React from "react";
import { Box, Container, Typography } from "@mui/material";
import Empower from "../../assets/images/empowerwinsuccess.png";
import CostEffective from "../../assets/images/costprice.png";
import CustomerService from "../../assets/images/customerservice.png";
import Relationship from "../../assets/images/customerrelation.png";
import Solutions from "../../assets/images/bulbidea.png";
import Safe from "../../assets/images/safesecure.png";
import useMediaQuery from "@mui/material/useMediaQuery";

function Mission() {
  const mobMatch = useMediaQuery("(max-width:600px)");
  
  const MissionBadge = (img, text) => {
    return (
      <Box
        sx={{
          width: { xs: "159px", sm: "258px" },
          display: "flex",
          alignItems: "center",
          columnGap: { xs: "4px", sm: "16px" },
        }}
      >
        <img
          width={mobMatch ? "40px" : "56px"}
          height={mobMatch ? "40px" : "56px"}
          src={img}
          alt="icon"
        />
        <Typography
          variant={mobMatch ? "subtitle2" : "h3"}
          sx={{
            fontSize: { xs: "14px", sm: "22px" },
            lineHeight: { xs: "20px", sm: "26px" },
            fontWeight: "600",
            width: { xs: "115px", sm: "186px" },
          }}
        >
          {text}
        </Typography>
      </Box>
    );
  };
  return (
    <Container
      disableGutters={true}
      sx={{
        padding: { xs: "24px 16px", sm: "0px" },
        marginY: { xs: "16px", sm: "72px" },
        borderRadius: { xs: "8px", sm: "0px" },
        backgroundColor: { xs: "#fff", sm: "none" },
      }}
    >
      <Box>
        <Typography
          variant={mobMatch ? "h3" : "h2"}
          sx={{
            fontSize: { xs: "22px", sm: "32px" },
            lineHeight: { xs: "26px", sm: "36px" },
            fontWeight: { xs: "600", sm: "700" },
            color: "text.primary",
            marginBottom: "8px",
            width: "383px",
          }}
        >
          Our mission is to empower our customers
        </Typography>
        <Typography
          variant={mobMatch ? "caption" : "body1"}
          sx={{
            fontSize: { xs: "12px", sm: "16px" },
            lineHeight: { xs: "16px", sm: "24px" },
            fontWeight: "400",
            color: "#616161",
          }}
        >
          At Machinery Planet, our mission is to empower our customers with
          technology, allowing them to leverage a creative, safe, and
          cost-effective platform to list their equipment. Our core values are
          the heart of all that we do.
        </Typography>
      </Box>
      <Box
        sx={{
          marginTop: "58px",
          display: "grid",
          gridTemplateColumns: { xs: "auto auto", sm: "auto auto auto auto" },
          rowGap: "56px",
        }}
      >
        {MissionBadge(Empower, "Empower Contractors")}
        {MissionBadge(CostEffective, "Cost Effective")}
        {MissionBadge(CustomerService, "Best Customer Service")}
        {MissionBadge(Relationship, "StraightForward Relationship")}
        {MissionBadge(Solutions, "Streamlined Solution")}
        {MissionBadge(Safe, "Safe Platform")}
      </Box>
    </Container>
  );
}

export default Mission;
